import React from 'react';
import App from './App';
import HomePage from './pages/HomePage';
import UsersListPage from './pages/UsersListPage';
import AdminsListPage from './pages/AdminsListPage';
import NotFoundPage from './pages/NotFoundPage';
import TourPage from './pages/TourPage';
import RoomPage from './pages/RoomPage';
import FacilityPage from './pages/FacilityPage';
import CaresPage from './pages/CaresPage';
import CorePage from './pages/CorePage';
import EducationsPage from './pages/EducationsPage'
import ContactusPage from './pages/ContactusPage';
import NewsPage from './pages/NewsPage';
import { Redirect } from 'react-router-dom';

// All route should be defined here for both client and server side router.
export default [
    {
        ...App,
        routes:  [
            {
                path: '/',
                exact: true,
                ...HomePage
            },
            {
                path: '/users',
                ...UsersListPage
            },
            {
                path: '/admins',
                ...AdminsListPage
            },
            // this must be placed before /tour, take priority
            {
                path: '/tour/rooms/:id',
                ...RoomPage
            },
            {
                path: '/tour/facilities/:id',
                ...FacilityPage
            },
            {
                path: '/tour',
                ...TourPage       
            },
            {
                path: '/cares/:id',
                ...CaresPage,
            },
            {
                path: '/cares',
                ...CaresPage,
            },
            {
                path: '/core/:id',
                ...CorePage,
            },
            {
                path: '/core',
                ...CorePage,
            },
            {
                path: '/educations',
                ...EducationsPage
            },
            // {
            //     path: '/contactus',
            //     ...ContactusPage,
            // },
            // {
            //     path: '/news',
            //     ...NewsPage,
            // },
            {
                ...NotFoundPage
            }
        ]
    }    
]


// WEBPACK FOOTER //
// ./src/client/Routes.js